import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { UserPermission } from '../models/permissions';
import { CognitoAuthService } from '../services/cognito-auth.service';

@Injectable({
  providedIn: 'root',
})
export class RolodexGuard {
  constructor(
    private cognitoAuthService: CognitoAuthService,
    private router: Router
  ) {}

  canActivate() {
    const user = this.cognitoAuthService.loggedInUser;
    const isAuthorized = user?.permissions.has(UserPermission.RolodexRead);

    if (!isAuthorized) {
      this.router.navigate(['']);
      return false;
    }

    return isAuthorized;
  }
}
